module.exports = __webpack_public_path__ + "media/assets/images/icon-exclamation-mark-red-b2f52cffa83a7051a0dae828ea6d1f77.svg";